
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmChatReviewDialog extends Vue {
  private visible: boolean = true;

  get message(): string {
    return `Are you sure ?`;
  }

  private reviewChat(): void {
    this.$emit('review');
    this.$emit('close');
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
